import {useEffect, useState, useContext} from 'react';
import {AppContext} from './AppContext';
import { useToast } from "@shopify/app-bridge-react";


export function ErrorsTable(props) {
    const [errorsList, setErrorsList] = useState( null)
    const [syncTime, setSyncTime] = useState( null);
    let {getBackendUrl} = useContext(AppContext);
    const {show} = useToast()


    useEffect(() => {
        async function getSyncErrors() {
            // const errors = await getBackendUrl('sync/get-errors');
            const errors = JSON.parse(process.env.REACT_APP_ERRORS_MOCK);
            if (errors.ok) {
                if (Object.keys(errors.errors).length === 0) {
                    show('Wohooo no errors');
                } else {
                    setErrorsList(errors.errors);
                    setSyncTime(errors.syncTimestamp);
                }
            } else {
                show('Error getting errors')
            }
        }
        getSyncErrors()
    }, [])
    console.log(errorsList)

    return(
        <>
            {errorsList !== null && <div>{Object.keys(errorsList).map((e => <div>{e}</div>))}</div>}
        </>
    )
}